import React from 'react';
// import PropTypes, { string } from 'prop-types';

import '../Input.scss';

interface CustomProps {
  default?: string;
  name?: string;
  placeholder?: string;
  autoComplete?: string;
  label?: string;
  gap?: 'sm' | 'md' | 'lg';
  size?: 'lg' | 'sm';
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
  autofocus?: boolean;
}

interface CustomState {
  value?: string;
}

class PasswordInput extends React.Component<CustomProps, CustomState> {
  static defaultProps: Partial<CustomProps> = {
    default: '',
    name: '',
    label: '',
    placeholder: '',
    gap: 'md',
    size: 'sm',
    onChange: () => {
      return;
    },
    error: '',
    disabled: false,
    autofocus: false,
  };
  constructor(props: CustomProps) {
    super(props);
    this.state = {
      value: props.default,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps: CustomProps) {
    if (prevProps.default !== this.props.default) {
      this.updateDefault();
    }
  }

  updateDefault() {
    if (this.props.default !== undefined) {
      this.setState({ value: this.props.default });
      this.props.onChange(this.props.default);
    }
  }

  handleChange(e: { target: any }) {
    const { value } = e.target;
    this.setState({ value });
    this.props.onChange(value);
  }

  render() {
    const {
      size,
      label,
      placeholder,
      name,
      gap,
      error,
      disabled,
      autoComplete,
    } = this.props;
    const extraClassesInput: string[] = [];
    if (size === 'lg') extraClassesInput.push('Input__field--lg');
    const extraClasses = extraClassesInput.join(' ');
    const inputIdCandidate = name || label || placeholder || '';
    const inputId = inputIdCandidate.toLowerCase().split(' ').join('-');
    return (
      <div className={`textField textField--margin-${gap}`}>
        {label && (
          <label className="textField__label" htmlFor={inputId}>
            {label}
          </label>
        )}
        <input
          id={inputId}
          className={`textField__input ${extraClasses}`}
          type="password"
          placeholder={placeholder}
          onChange={this.handleChange}
          value={this.state.value}
          disabled={disabled}
          autoComplete={autoComplete}
          autoFocus={this.props.autofocus}
        />

        {error && <span className="textField__validation">{error}</span>}
      </div>
    );
  }
}

export default PasswordInput;
